// src/services/apiService.js
import axios from "axios";

const API_BASE_URL = "https://api.optionbricks.in/api";                   //"http://localhost:4000/api";  // "https://stockmantra.onrender.com/api"; // ⚙️ change for production

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// 1️⃣ SEND OTP
export const sendOtp = async (email) => {
  const res = await api.post("/otp/send", { email });
  return res.data;
};

// 2️⃣ VERIFY OTP
export const verifyOtp = async (email, otp) => {
  const res = await api.post("/otp/verify", { email, otp });
  return res.data;
};

// 3️⃣ FORM SUBMISSION (multipart with PAN + AADHAAR)
export const submitForm = async (formData) => {
  const res = await axios.post(`${API_BASE_URL}/submit`, formData, {
  // const res = await axios.post(`/api/submit`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// 4️⃣ SEND AGREEMENT EMAIL (📩 only email body)
export const sendAgreement = async (email , signatureBase64) => {
  const res = await api.post("/send-agreement", { email , signatureBase64});
  return res.data;
};

// 5️⃣ OPEN INVOICE (in browser tab)
export const openInvoice = (txnId) => {
  window.open(`${API_BASE_URL}/invoice/${txnId}`, "_blank");
};

// 6️⃣ COMPLAINT BOARD — latest published version of each of the three
// independently-versioned tables ({ complaint, monthly, annual }); normalize
// to the shape the page renders.
export const getComplaintBoard = async () => {
  const res = await api.get("/complaint-board");
  const data = res.data?.data ?? {};
  return {
    complaintBoardData: data.complaint?.rows ?? [],
    monthlyTrendData: data.monthly?.rows ?? [],
    annualTrendData: data.annual?.rows ?? [],
  };
};

export default {
  sendOtp,
  verifyOtp,
  submitForm,
  sendAgreement,
  openInvoice,
  getComplaintBoard,
};
